export const getCountryIcon = (key: string) => {
  if (key && key.length) {
    try {
      const icon = import(
        `../../../../assets/icons/countries/${key.toLowerCase()}.svg`
      ).then((image) => image.default);
      return icon;
    } catch (e: any) {
      const def = import(`../../../../assets/icons/countries/generic.svg`).then(
        (image) => image.default,
      );
      return def;
    }
  } else {
    const def = import(`../../../../assets/icons/countries/generic.svg`).then(
      (image) => image.default,
    );
    return def;
  }
};
export const getTransactionIcon = (transaction: any) => {
  return import(`../../../../assets/icons/transactions/${transaction.type}.svg`)
    .then((image) => image.default)
    .catch((e) =>
      import(`../../../../assets/icons/transactions/generic.svg`).then(
        (image) => image.default,
      ),
    );
};
